import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'typeFilter'
})
export class TypeFilterPipe implements PipeTransform {
  transform(value, type?: any): any {
    if (!value) { return null; }
    const keys = [];
    let jsonResult;
    try {
      jsonResult = JSON.parse(value);
    } catch (error) {
      try {
        jsonResult = JSON.parse(value.replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t').replace(/\f/g, '\\f'));

      } catch (error) {
        return null;
      }
    }
    for (const key in jsonResult) {
      if ((type === 'string' && (typeof jsonResult[key] === 'string' || typeof jsonResult[key] === 'number' || typeof jsonResult[key] === 'boolean' ||  (Array.isArray(jsonResult[key]) &&  jsonResult[key].length && typeof jsonResult[key][0] === 'string'))) || typeof jsonResult[key] === type) { keys.push(key); }
    }
    return keys;
  }
}
